'use strict';
import '@/_constant/global';
import { createApp } from 'vue';
import App from '@/_modules/App.vue';
import store from '@/_modules/store';
import router from '@/_modules/router';

document.addEventListener('DOMContentLoaded', () => {
  gPG.rootHTML.classList.add('is-body-fixed');
  
  // vue3
  const app = createApp(App);
  app.use(store);
  app.use(router);
  app.mount('#c-container');
}, false);

window.addEventListener('load', () => {}, false);

window.addEventListener('unload', () => {}, false);
